var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-2 text-center"},[_c('v-img',{staticClass:"mx-auto",attrs:{"contain":"","max-height":_vm.$vuetify.application.top - 15,"max-width":"60%","src":_vm.logo}}),_c('app-name',{attrs:{"compact":_vm.compact}}),_c('span',{class:_vm.getClass},[_vm._v(_vm._s(`v${_vm.version}`))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }